import { render, staticRenderFns } from "./kirbyimage.vue?vue&type=template&id=5f42d9d2"
import script from "./kirbyimage.vue?vue&type=script&lang=js"
export * from "./kirbyimage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports